import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import { css } from '@emotion/react';

import { COLORS2, LAYOUT2, TYPOGRAPHY2 } from '../../../Styles';
import { ClearIcon, SearchIcon } from './ScanNavigatorIcons';

const SEARCH_OUTER_CONTAINER_STYLE = css`
  label: SEARCH_OUTER_CONTAINER_STYLE;
  padding: 0 ${LAYOUT2.spacing2}px;
`;

const SEARCH_CONTAINER_STYLE = css`
  label: SEARCH_CONTAINER_STYLE;
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${COLORS2.alwaysDark.background.light};
  padding: 0 ${LAYOUT2.spacing2}px;
  height: ${LAYOUT2.spacing5}px;
`;

const SEARCH_INPUT_STYLE = css`
  label: SEARCH_INPUT_STYLE;
  flex: 1;
  padding: ${LAYOUT2.spacing1}px ${LAYOUT2.spacing6}px ${LAYOUT2.spacing1}px 0;
  background: transparent;
  border: none;
  outline: none;
  height: 45px;
  color: ${COLORS2.alwaysDark.text.white};
  ${TYPOGRAPHY2.xSmall};
  ::placeholder {
    color: ${COLORS2.alwaysDark.text.darkGray};
  }
`;

const SEARCH_ICON_STYLE = css`
  label: SEARCH_ICON_STYLE;
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  width: 45px;
  height: 45px;
`;

const CLEAR_BUTTON_STYLE = css`
  label: CLEAR_BUTTON_STYLE;
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${COLORS2.alwaysDark.text.darkGray};
  width: 45px;
  height: 45px;

  &:hover {
    color: ${COLORS2.alwaysDark.text.white};
  }
`;

export const ScanNavigatorSearchBar = ({
  setFilter,
  filter,
}: {
  setFilter: (filter: string) => void;
  filter: string;
}) => {
  const [localFilter, setLocalFilter] = useState('');
  useEffect(() => setLocalFilter(filter), [filter]);
  const debouncedSetFilter = useDebouncedCallback(setFilter, 500);

  return (
    <div css={SEARCH_OUTER_CONTAINER_STYLE}>
      <div css={SEARCH_CONTAINER_STYLE}>
        <input
          css={SEARCH_INPUT_STYLE}
          value={localFilter}
          onChange={e => {
            setLocalFilter(e.target.value);
            debouncedSetFilter(e.target.value);
          }}
          placeholder='filter all'
        />
        {localFilter
          ? (
            <button css={CLEAR_BUTTON_STYLE} onClick={() => setFilter('')} aria-label='Clear search'>
              <ClearIcon />
            </button>
          )
          : (
            <span css={SEARCH_ICON_STYLE}>
              <SearchIcon />
            </span>
          )}
      </div>
    </div>
  );
};
